import React from 'react';
import './layout.css';
import NavBar from './navbar/navbar';

/**
 * Layout Component
 * 
 * Main application layout wrapper providing consistent page structure with
 * navigation bar at the top and main content area below. Wraps all page routes
 * to ensure navbar appears on every page.
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Page content to render in main area
 * @returns {JSX.Element} Application layout with navigation and content area
 */
const Layout = ({ children }) => {
  return (
    <div className="app-root">
      {/* Navigation bar appears on all pages */}
      <NavBar />
      {/* Main content area for page-specific content */}
      <main className="main-content">{children}</main>
    </div>
  );
};

export default Layout;
